function backGroundColorFestivos(instance, td) {
    td.style.backgroundColor = 'red';
  }

  export default backGroundColorFestivos

 